import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["data-addons"]

import { computed, toRef } from 'vue'

import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { sectionCopy, UPSELL_LEADS } from '@/config/agentWizardSteps'
import AgentChooseSection from '@/view/ai/agentWizard/steps/AgentChooseSection.vue'
import AgentMessageField from '@/view/ai/agentWizard/steps/AgentMessageField.vue'
import AgentStoresSection from '@/view/ai/agentWizard/steps/AgentStoresSection.vue'
import { useStoreStepTarget } from '@/view/ai/agentWizard/steps/useStoreStepTarget'

const NO_ADDONS = 'No add-ons yet. The agent is created but waits until you add products under Store › Upsells.'


export default {
  __name: 'AgentStepUpsell',
  props: { storeId: { type: String, default: null } },
  setup(__props) {

const LEAD_OPTIONS = UPSELL_LEADS.map(({ key, label }) => ({ name: label, value: key }))
const props = __props

const { wizard, section, subStore, target, showFields } = useStoreStepTarget('upsell', toRef(props, 'storeId'))

const listedStores = computed(() =>
  subStore.value ? [subStore.value] : wizard.stores.value.filter(store => section.store_ids.includes(String(store.id)))
)
const copy = key => sectionCopy(key, wizard.data, wizard.ctx)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(subStore))
      ? (_openBlock(), _createBlock(AgentChooseSection, {
          key: 0,
          "step-key": "upsell"
        }))
      : _createCommentVNode("", true),
    (_unref(section).enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('upsell.addons'))), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listedStores.value, (store) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: store.id,
                  "data-addons": store.upsell_products_count > 0 ? 'ready' : 'none',
                  class: _normalizeClass(["m-0 text-sm", store.upsell_products_count > 0 ? 'text-green-700' : 'rounded-md bg-amber-50 px-3 py-2 text-amber-800'])
                }, [
                  (store.upsell_products_count > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(WizardIcon, {
                          name: "check",
                          class: "mr-1 inline-block h-4 w-4 align-text-bottom"
                        }),
                        _createTextVNode(" " + _toDisplayString(`${store.store_name}: ${store.upsell_products_count} add-ons in your Upsell category`), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(`${store.store_name}: ${NO_ADDONS}`) + " ", 1),
                        _createVNode(_component_router_link, {
                          to: "/store/upsells",
                          class: "font-medium underline"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Add products", -1)
                          ]))]),
                          _: 1
                        })
                      ], 64))
                ], 10, _hoisted_1))
              }), 128))
            ]),
            _: 1
          }, 16),
          (_unref(showFields))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(WizardSection, _mergeProps(copy('upsell.lead'), { plain: "" }), {
                  default: _withCtx(() => [
                    _createVNode(PillRadioGroup, {
                      modelValue: _unref(target).lead,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(target).lead) = $event)),
                      options: _unref(LEAD_OPTIONS),
                      label: "How long before cutoff"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('upsell.message'))), {
                  default: _withCtx(() => [
                    _createVNode(AgentMessageField, {
                      modelValue: _unref(target).message,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(target).message) = $event)),
                      label: "First text"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(AgentStoresSection, {
            "step-key": "upsell",
            "sub-step": Boolean(_unref(subStore))
          }, null, 8, ["sub-step"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

}